import React from "react";
import Menu from "../Menu";

const SendDynamicQr = () => {
  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <div>
            <div id="verificationResult" className="mt-8" />
            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <h1
                  className="font-bold text-3xl max-sm:text-sm mb-5 col-span-2"
                  id="messagehd"
                >
                  Welcome Screen
                </h1>
                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Welcome Screen
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Welcome Screen Data
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={
                      '{"screen":"WelcomeScreen","data":{"title":"Welcome to Easovation Solutions","img":""}}'
                    }
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Welcome Screen
                  </button>

                  <h1
                    className=" mt-8 font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    TextBox
                  </h1>
                  <textarea
                    className="w-full md:w-[13rem] h-[2.5rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={"Welcome to Easovation Solutions"}
                  />
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Create Sound File
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <h1
                  className="font-bold text-3xl max-sm:text-sm mb-5 col-span-2"
                  id="messagehd"
                >
                  Display Total Screen
                </h1>

                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Total Screen
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Display Total Screen Data
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={
                      '{"screen":"DisplayTotalScreen","data":{"TotalAmount":100,"DiscountAmount":20,"TaxAmount":10,"GrandTotal":90,"img":""}}'
                    }
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Total Screen
                  </button>

                  <h1
                    className=" mt-8 font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    TextBox
                  </h1>
                  <textarea
                    className="w-full md:w-[13rem] h-[2.5rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={"Your Bill total is Rs. 100"}
                  />
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Create Sound File
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <h1
                  className="font-bold text-3xl max-sm:text-sm mb-5 col-span-2"
                  id="messagehd"
                >
                  Display QR Code Screen
                </h1>

                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display QR Code Screen
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Display QR Code Screen Data
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={
                      '{"screen":"DisplayQRCodeScreen","data":{"QrCodeBase64":"","UPIUrl":"upi://pay?pa=63270083167.payswiff@indus&pn=Bonrix&cu=INR&am=10&pn=Bonrix%20Software%20Systems","Amount":10,"CompanyNam":"Bonrix Software Systems","ShopName":"Easovation","img":""}}'
                    }
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display QR Code Screen
                  </button>

                  <h1
                    className=" mt-8 font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    TextBox
                  </h1>
                  <textarea
                    className="w-full md:w-[13rem] h-[2.5rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={"Please Pay Rs. 10 for Your Bill"}
                  />
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Create Sound File
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <h1
                  className="font-bold text-3xl max-sm:text-sm mb-5 col-span-2"
                  id="messagehd"
                >
                  Display Success QR Code Screen
                </h1>

                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Success QR Code Screen
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Display Success QR Code Screen Data
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={
                      '{"screen":"DisplaySuccessQRCodeScreen","data":{"OrderId":123567,"BankRef":21354,"Amount":100,"Date":1726051558858,"img":""}}'
                    }
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Success QR Code Screen
                  </button>

                  <h1
                    className=" mt-8 font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    TextBox
                  </h1>
                  <textarea
                    className="w-full md:w-[13rem] h-[2.5rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={"Rs. 10 Received, Transaction is Successful"}
                  />
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Create Sound File
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <h1
                  className="font-bold text-3xl max-sm:text-sm mb-5 col-span-2"
                  id="messagehd"
                >
                  Display Cancel QR Code Screen
                </h1>

                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Cancel QR Code Screen
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Display Cancel QR Code Screen Data
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={
                      '{"screen":"DisplayCancelQRCodeScreen","data":{"OrderId":123567,"BankRef":21354,"Amount":1000,"Date":1726051558858,"img":""}}'
                    }
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Cancel QR Code Screen
                  </button>

                  <h1
                    className=" mt-8 font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    TextBox
                  </h1>
                  <textarea
                    className="w-full md:w-[13rem] h-[2.5rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={"Transaction Cancelled"}
                  />
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Create Sound File
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <h1
                  className="font-bold text-3xl max-sm:text-sm mb-5 col-span-2"
                  id="messagehd"
                >
                  Display Fail QR Code Screen
                </h1>

                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Fail QR Code Screen
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Display Fail QR Code Screen Data
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={
                      '{"screen":"DisplayFailQRCodeScreen","data":{"OrderId":123567,"BankRef":21354,"Amount":2000,"Date":1726051558858,"img":""}}'
                    }
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Display Fail QR Code Screen
                  </button>

                  <h1
                    className=" mt-8 font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    TextBox
                  </h1>
                  <textarea
                    className="w-full md:w-[13rem] h-[2.5rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={"Transaction Cancelled"}
                  />
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Create Sound File
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Sound File WAV Data
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={
                      '{"bc_type":"01","req_id":1234,"voice_data":"","voice_type":"wav"}'
                    }
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Sound File WAV Data
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <input type="file" className=" col-span-2" name="File" />

                <div className="col-span-1">
                  <button
                    className="mt-8 md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Upload Sound File
                  </button>
                </div>
              </div>
            </div>

            <div className=" max-sm:mt-5 py-5 px-[10rem] max-sm:px-10 bg-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
                <div className="col-span-2">
                  <h1
                    className="font-bold text-3xl max-sm:text-sm mb-5"
                    id="messagehd"
                  >
                    Text To Speech
                  </h1>
                  <textarea
                    className="w-full md:w-[32rem] h-[10rem] max-sm:h-16 p-2 border border-gray-300 rounded"
                    id="msg"
                    name="msg"
                    rows={4}
                    cols={50}
                    defaultValue={""}
                  />
                </div>
                <div className="col-span-1">
                  <button
                    className=" md:mt-0 max-md:text-sm max-sm:text-xs border border-gray-300 max-md:px-12 px-5 py-2 bg-blue-500 text-white rounded-lg focus:ring-4 ring-blue-200 md:w-auto w-full"
                    id="sendMsgBtn"
                  >
                    Create WAV File
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendDynamicQr;
